import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { ConfigService } from '../../core/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ApecoToastrService {
  defaultOptions: any = {
    timeOut: this.config.toastrTimeout,
    closeButton: true
  };

  constructor(
    private toastr: ToastrService,
    private translation: TranslateService,
    private config: ConfigService
  ) {}

  info(message: string, title?: string, options?: any): ActiveToast<any> {
    return this.toastr.info(message, title, {
      ...this.defaultOptions,
      ...(options || {})
    });
  }

  success(message?: string, title?: string, options?: any): ActiveToast<any> {
    message ??= this.translation.instant('general-success-msg');

    return this.toastr.success(message, title, {
      ...this.defaultOptions,
      ...(options || {})
    });
  }

  error(message?: string, title?: string, options?: any): ActiveToast<any> {
    message ??= this.translation.instant('general-error');

    return this.toastr.error(message, title, {
      ...this.defaultOptions,
      ...(options || {})
    });
  }
}
